/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;


    const searchTerm = this.getQuery().toLowerCase();

    const suggestions = this.predictiveSearchResults.querySelectorAll(
      '.thb-predictive-search--popular .predictive-search__item'
    );

    suggestions.forEach(item => {
      const fullText = item.dataset.term;
      const lowerText = fullText.toLowerCase();

      if (!lowerText.startsWith(searchTerm)) {
        item.style.display = 'none';
        return;
      }

      item.style.display = '';

      console.log(fullText.slice(0, searchTerm.length));
      console.log(fullText.slice(searchTerm.length));
      console.log(fullText.slice(0, searchTerm.length) + fullText.slice(searchTerm.length));
      
      item.innerHTML =
      
        `<span class="ps-rest"><strong class="ps-highlight"> ${fullText.slice(0, searchTerm.length)}</strong>` +
        `${fullText.slice(searchTerm.length)}</span>
        `;
    });

    // let _this = this,
    //   submitButton = this.container.querySelector('#search-results-submit');


    // submitButton.addEventListener('click', () => {
    //   _this.form.submit();
    // });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});


// Recent search logic

(function () {
  const STORAGE_KEY = 'recent_searches';
  const LIMIT = 6;

  const container = document.querySelector('.recent-searches');
  const list = container?.querySelector('.recent-searches__list');

  if (!container || !list) return;

  function getSearchInput() {
    return document.querySelector('#Search-Drawer input[type="search"]');
  }

  function saveSearch(term) {
    if (!term) return;

    term = term.trim().toLowerCase();
    if (!term) return;

    let searches = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    searches = searches.filter(item => item !== term);
    searches.unshift(term);
    searches = searches.slice(0, LIMIT);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
    render();
  }

  function render() {
    const searches = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (!searches.length) {
      container.hidden = true;
      return;
    }

    container.hidden = false;

    list.innerHTML = searches.map(term => `
      <li class="recent-searches__item">
        <a href="/search?q=${encodeURIComponent(term)}">${term}</a>
        <button
          type="button"
          class="recent-searches__remove"
          data-term="${term}"
          aria-label="Remove ${term}">
          ×
        </button>
      </li>
    `).join('');
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;

    const input = getSearchInput();
    if (!input || document.activeElement !== input) return;

    saveSearch(input.value);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.recent-searches')) return;

    const link = event.target.closest('a[href*="/search"]');
    if (!link) return;

    try {
      const url = new URL(link.href, window.location.origin);
      const term = url.searchParams.get('q');
      if (term) saveSearch(term);
    } catch (e) { }
  });

  list.addEventListener('click', (event) => {
    const btn = event.target.closest('.recent-searches__remove');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const termToRemove = btn.dataset.term;

    let searches = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    searches = searches.filter(item => item !== termToRemove);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
    render();
  });

  render();

})();